var map = {
	"./package-lock.json": [
		"iSgU",
		14
	],
	"./package.json": [
		"kiQV",
		15
	],
	"./public/translations/components/DynamicTranslations/ar.json": [
		"llsz",
		16
	],
	"./public/translations/components/DynamicTranslations/en.json": [
		"orHF",
		17
	],
	"./public/translations/components/Header/ar.json": [
		"euGN",
		18
	],
	"./public/translations/components/Header/en.json": [
		"2MoU",
		19
	],
	"./public/translations/components/RosettaImage/ar.json": [
		"FkxG",
		20
	],
	"./public/translations/components/RosettaImage/en.json": [
		"w5uG",
		21
	],
	"./public/translations/components/SwitchButton/ar.json": [
		"BE2e",
		22
	],
	"./public/translations/components/SwitchButton/en.json": [
		"Pqwi",
		23
	],
	"./public/translations/components/SwitchLink/ar.json": [
		"Hoih",
		24
	],
	"./public/translations/components/SwitchLink/en.json": [
		"H4CR",
		25
	],
	"./public/translations/components/Title/ar.json": [
		"OQWa",
		26
	],
	"./public/translations/components/Title/en.json": [
		"ddTZ",
		27
	],
	"./public/translations/pages/[language]/dynamic/ar.json": [
		"Lwvn",
		28
	],
	"./public/translations/pages/[language]/dynamic/en.json": [
		"TTUN",
		29
	],
	"./public/translations/pages/[language]/index/ar.json": [
		"tU22",
		30
	],
	"./public/translations/pages/[language]/index/en.json": [
		"QVMW",
		31
	],
	"./public/translations/pages/[language]/ssr/ar.json": [
		"kU27",
		32
	],
	"./public/translations/pages/[language]/ssr/en.json": [
		"U3AN",
		33
	],
	"./public/translations/pages/_app/ar.json": [
		"1efg",
		34
	],
	"./public/translations/pages/_app/en.json": [
		"k59Q",
		35
	],
	"./tsconfig.json": [
		"wHjn",
		36
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "+Js4";
module.exports = webpackAsyncContext;